import { createComponent, IntrinsicProps } from '@common/util/templateHelpers';
import Link from 'next/link';

interface BreadcrumbProps extends IntrinsicProps {
  parentHref: string;
  parentName: string;
  childName: string;
}

export default createComponent <BreadcrumbProps> ('Breadcrumb', 
  {}, 
  function Breadcrumb ({ className, style }, props) {
    return (
      <div className={className} style={style}>
        <span className='Breadcrumb__Parent'>
          <Link href={props.parentHref}>{props.parentName}</Link>
        </span> » <span className='Breadcrumb__Child'>
          { props.childName }
        </span>
      </div>
    );
  });
